<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="214"> </caass-schoolselector>
						</div>
					</div>

					<!--ByType-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">By Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ByTypeID" [(ngModel)]="report.ByTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ByTypeList" [ngValue]="o.ByTypeID">
									{{ o.ByTypeName }}
								</option>
							</select>
						</div>
					</div>

					<!--Columns-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Columns</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ColumnsID" [(ngModel)]="report.ColumnsID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ColumnsList" [ngValue]="o.ColumnsID">
									{{ o.ColumnsName }}
								</option>
							</select>
						</div>
					</div>

					<!--Option Specific:---------------------------------------------------------------------------------------------------------->

					<!--AcademyID-->
					<div *ngIf="report.ByTypeID == 'Academy'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AcademyID" [(ngModel)]="report.AcademyID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of AcademyList" [ngValue]="o.AcademyId">
									{{ o.AcademyDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--PageByACAD-->
					<div *ngIf="report.ByTypeID == 'Academy'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">New Page By Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PageByACADID" [(ngModel)]="report.PageByACADID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--GradeLevelID-->
					<div *ngIf="report.ByTypeID == 'Grade'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade Level</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GradeLevelID" [(ngModel)]="report.GradeLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GradeLevelList" [ngValue]="o.GradeLevelID">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--GroupID-->
					<div *ngIf="report.ByTypeID == 'Group'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GroupID" [(ngModel)]="report.GroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GroupList" [ngValue]="o.GroupID">
									{{ o.GroupName }}
								</option>
							</select>
						</div>
					</div>

					<!--PageByACAD-->
					<div *ngIf="report.ByTypeID == 'Group'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">New Page By Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PageByGroup" [(ngModel)]="report.PageByGroup">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--HomeRoomID-->
					<div *ngIf="report.ByTypeID == 'Homeroom'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="HomeRoomID" [(ngModel)]="report.HomeRoomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of HomeroomList" [ngValue]="o.HomeroomId">
									{{ o.HomeRoom }}
								</option>
							</select>
						</div>
					</div>

					<!--PageByHR-->
					<div *ngIf="report.ByTypeID == 'Homeroom'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">New Page By Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PageByHR" [(ngModel)]="report.PageByHR">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--TeacherPersonID-->
					<div *ngIf="report.ByTypeID == 'Instructor'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Instructor</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="TeacherPersonID" [(ngModel)]="report.TeacherPersonID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of TeacherPersonList" [ngValue]="o.Teacher_PersonID">
									{{ o.Instructor }}
								</option>
							</select>
						</div>
					</div>

					<!--SemesterID-->
					<div *ngIf="report.ByTypeID == 'Instructor'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Semester</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="HomeRoomID" [(ngModel)]="report.SemesterID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SemesterList" [ngValue]="o.SemesterID">
									{{ o.Semester }}
								</option>
							</select>
						</div>
					</div>

					<!--DayID-->
					<div *ngIf="report.ByTypeID == 'Instructor'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Day</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="DayID" [(ngModel)]="report.DayID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of DayList" [ngValue]="o.DayID">
									{{ o.DayDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--BySection-->
					<div *ngIf="report.ByTypeID == 'Instructor'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">New Page By Section</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BySection" [(ngModel)]="report.BySection">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--ORDERBY-->
					<div *ngIf="report.ByTypeID == 'School'" class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Order By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PageByHR" [(ngModel)]="report.ORDERBY">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ORDERBYList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!---------------------------------------------------------------------------------------------------------------------------->

					<!--W_ID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">ID Number</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_ID" [(ngModel)]="report.W_ID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--W_HPhone-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Phone</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_HPhoneID" [(ngModel)]="report.W_HPhoneID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--W_HRoom-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_HRoomID" [(ngModel)]="report.W_HRoomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--W_DOB-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">DOB</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_DOBID" [(ngModel)]="report.W_DOBID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--W_Name-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Name</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_NameID" [(ngModel)]="report.W_NameID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YNList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
